var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.971,
    height: 28,
    viewBox: "0 0 19.971 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#304785;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.2,1.512,12.28,0,9.359,1.512l-3.252.493L4.634,4.945l-2.34,2.31L2.829,10.5l-.536,3.245,2.34,2.31,1.474,2.94,3.252.493L12.28,21,15.2,19.488l3.252-.493,1.473-2.94,2.34-2.31L21.729,10.5l.535-3.245-2.34-2.31-1.473-2.94ZM17.293,3.6l1.2,2.389,1.9,1.876L19.957,10.5l.434,2.635-1.9,1.876-1.2,2.389-2.643.4L12.28,19.029,9.908,17.8l-2.642-.4-1.2-2.389-1.9-1.876L4.6,10.5,4.167,7.865l1.9-1.876L7.266,3.6l2.643-.4L12.28,1.971,14.652,3.2l2.641.4Z",
    transform: "translate(-2.294)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,11.794v7.36l7-1.75,7,1.75v-7.36l-3.531.535L11,14.125l-3.469-1.8Z",
    transform: "translate(-1.013 8.846)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.bf0bb3c1198ddcf656b56211c0c43d8c.svg";
export { ForwardRef as ReactComponent };